/**
 * @module components\TxnHistory
 */
import Vue from 'vue';
import Component from 'vue-class-component';
import { required, requiredIf } from "vuelidate/lib/validators";
import core from '@/services/core';
import store from '@/store';
import _ from "lodash";
import moment from 'moment';
import * as XLSX from "xlsx";;

@Component({
    validations: function (this: Transhistory) {
        let validation: any = {
          searchBy: { required },
          type: {
            required: requiredIf(() => { return (this.searchBy == "Group") }),
          },
          clientName: {
            required: requiredIf(() => { return (this.searchBy == "Client Name") }),
          },
          SearchField:{
            required: requiredIf(() => { return (this.searchBy == "SMA" || this.searchBy == "Group") }),
          }
    }
        return validation;

    }
    
})
export default class Transhistory extends Vue {
    page = 1;
    historys = [];
    userSearch = "";
    pageCount = 0;
    searchBy = '';
    searchItem = ['Group', 'SMA', 'Client Name'];
    type = '';
    typeOfItem = ['Client', 'SMA'];
    clientNameList = [];
    clientName = '';
    SearchField = "";
    finoClientId = "";
    historyResponse: any = null;
    filterE = '';
    filterA = "";
    headers = [];
    isFilterEnable: boolean;
    btnTxt: string;
    transInfo = false;
    detailsHeaders = [];
    detailsValues = [];
    counter: number=1;
    fetchCommPlanRequest = {};
    json_fields = {};
    dataExcel = [];
    downloadFile = false;
    downloadFileLoader = true;
    requestType= '';
    pageNumberToHitAPI = 0;
    recordNumber = 1;

  tab = store.getters.tabKeyGet.tab
  reqModule = store.getters.tabKeyGet.requestModule
  headerExcel: any;

fetchTxnHistory(reqType, isBtn) {
    if (this.$v.$invalid && reqType == 'VIEW' && isBtn) {
      this.$v.$touch();
      return;
    }
    if (reqType == 'VIEW' && isBtn) {
      this.historys = [];
      this.requestType = reqType;
    } else {
      this.requestType = 'DOWNLOAD';
      this.downloadFile = true;
    }
    let filterD_SpiceTxnId = "";
  
   switch (this.searchBy) {
    case 'Group':
      this.reqModule = this.type === 'Client' ? 'GROUP_CLIENT' : 'GROUP_SMA';
      break;
    case 'SMA':
      this.reqModule = 'SMA_COMM';
      this.filterE = this.SearchField;
      break;
    case 'Client Name':
      this.reqModule = 'CLIENT_COMM';
      break;
  }
  

  if (this.searchBy === 'SMA' || (this.type === 'Client' || this.type === 'SMA') && this.searchBy === 'Group') {
    this.filterA = this.SearchField;
  }
   
  let agg_id = this.getfinoClientid(this.clientName);
    this.fetchCommPlanRequest = { "token": store.getters.sessLoginDataGet.sessionId, "merchantClientId": store.getters.sessLoginDataGet.clientId, "requestType": this.requestType, "requestModule": this.reqModule, "recordNumber": this.requestType=='DOWNLOAD'?this.counter:this.recordNumber, "finoClientId": this.clientName, "aggId":agg_id, "filter_A": this.filterA, "filter_B": "", "filter_C": "", "filter_D": filterD_SpiceTxnId, "filter_E": this.filterE, "tabKey": this.tab };
    core
      .post({
        data: this.fetchCommPlanRequest,
        url: 'fetchCommPlan',
        method: 'post'
      })
      .then(response => {
        if (this.requestType == 'VIEW') {
          this.historyResponse = response;
        this.isFilterEnable = true;
        this.btnTxt = "Clear Filters";
        if (response.historyData.length > 0) {
          if (isBtn) {
            this.historys = [];
            this.dataExcel = [];
            this.counter = 0;
          }
          response.historyData.sort((a, b) => parseInt(b.col1) - parseInt(a.col1));
          this.historys.push(...response.historyData);
          this.headers = response.headers;
          this.setDrawerState();
        }
        if (response.historyData.length <= 0) {
          //this.historys=[];
        }
        } else {
          if (response.headers) {
        response.headers.forEach(element => {
          if (element.text !== response.clickableColumnName) {
            this.json_fields[element.text] = element.value;
          }
        });
        this.headerExcel = response.headers;
        // this.headerExcel.push({ text: "Receipt", value: "colS01", sortable: false });
        console.log(this.headerExcel);
      }
      this.dataExcel.push(...response.historyData);
      
      // Continue fetching if not end of file
      if (!response.isEof) {
        this.counter++;
        this.fetchTxnHistory("DOWNLOAD",true);
      } else {
        this.counter = 1;
        this.downloadFileLoader = false;
      }
        }
        
      })
      .catch(error => {
        this.isFilterEnable = true;
        this.btnTxt = "Clear Filters";
        console.log(error)
      });
 
  
    }
    setDrawerState() {
    store.dispatch('updateUserNavDataAc', false)
  }

   get staticData() {
    return store.getters.staticDataGet;
  }

   fileName() {
    return moment().unix();
  }
  getCommissionDetail(rowData) {
      let request = { "transactionId":"","token": store.getters.sessLoginDataGet.sessionId, "merchantClientId": store.getters.sessLoginDataGet.clientId, "requestType": "VIEW", "requestModule": "COMM", "recordNumber": 0, "finoClientId": "", "aggId":"", "filter_A": "", "filter_B": "", "filter_C": "", "filter_D": "", "filter_E": rowData, "tabKey": this.tab };
    core
      .post({
        data: request,
        url: 'transdetailHist',
        method: 'post'
      })
      .then(response => {
        this.detailsHeaders = response.headers;
        this.detailsValues = response.historyData;
        this.transInfo = true;
      })
      .catch(error => {
        this.isFilterEnable = true;
        this.btnTxt = "Clear Filters";
        console.log(error)
      });
  }

getStatusColor(status) {
    switch (status && status.toUpperCase()) {
      case 'SUCCESS':
        return 'color:#34a853';
      case 'FAILED':
        return 'color:#ea4335';
      case 'PENDING':
      case 'INITIATED':
        return 'color:#E88A00';
      default:
        return '';
    }
    return '';
  }

 mounted() {
   if (this.tab == 'UPLOAD_COMM')
     this.clientNameList = _.orderBy(this.staticData.payload.ccSearchModule, 'displayName');
  }
  getfinoClientid(aggId) {
    let finoId = this.clientNameList.find(obj => obj.value == aggId);
    return finoId ? finoId.agg_id : "";
  }

  onexport() { // On Click Excel download button

    // export json to Worksheet of Excel
    // only array possible
    let excelData = [];
    console.log(this.dataExcel);
    excelData = _.cloneDeep(this.dataExcel);
    console.log(excelData);
    
    excelData.forEach((obj) => {
      for (const [key, value] of Object.entries(obj)) {
        this.headerExcel.forEach((head) => {
          if (head.value == key) {
            obj[head.text] = value;
            // if (head.text == this.historyResponse.clickableColumnName) {
            //   delete obj[head.text];
            // }
            delete obj[key];
          } else {
            delete obj[key];
          }
        })
      }
    })
    var SheetWS = XLSX.utils.json_to_sheet(excelData);
    // A workbook is the name given to an Excel file
    var wb = XLSX.utils.book_new() // make Workbook of Excel
    // add Worksheet to Workbook
    // Workbook contains one or more worksheets
    XLSX.utils.book_append_sheet(wb, SheetWS, 'Sheet1') // sheetAName is name of Worksheet
    // export Excel file
    XLSX.writeFile(wb, `${this.fileName()}.xlsx`) // name of the file is 'book.xlsx'*/
  }

  clearFilter() {
      this.type = '';
      this.clientName = '';
      this.SearchField = '';
      this.historys = [];
      this.headers = [];
  }
  clearFilter2() {
    this.SearchField = '';
      this.historys = [];
      this.headers = [];
  }
  get mobileTableData() {
   
      return this.historys.slice(
        (this.page - 1) * this.historyResponse.pageSize,
        this.page * this.historyResponse.pageSize
      );
  }
  get paginationLength() {
    if (this.historys.length === 0) {
      return 0;
    }
    const temp = (
      this.historys.length / this.historyResponse.pageSize
    ).toString();
    let pagesToBeAdded = 0;
    if (this.historyResponse.isEof === false) {
      pagesToBeAdded = 1;
    }
    let pages = 0;
    if (temp.includes('.')) {
      pages = +temp.split('.')[0] + 1;
      this.pageNumberToHitAPI = pages;
    } else {
      pages = +temp + pagesToBeAdded;
      this.pageNumberToHitAPI = pages;
    }
    if (this.historyResponse.isEof === true) {
      this.pageNumberToHitAPI = 0;
    }

    return pages;
  }
  changePageNumber(pageNumber: number) {
    if (pageNumber === this.pageNumberToHitAPI) {
      this.recordNumber = this.recordNumber + 1;
      this.pageNumberToHitAPI = 0;
      this.fetchTxnHistory('VIEW', false)
    }
  }
}
